import { get } from "lodash";

const styles = (theme) => ({
  fieldContainer: {
    padding: `0px ${get(theme, 'padding.p10')}`,
    margin: '0 !important',
    minWidth: 200,
  },
  listContent: {
    margin: get(theme, 'margin.m0'),
  },
  pageBodyClass: {
    paddingTop: get(theme, 'padding.p0'),
  },
  pageFilterAndSortClass: {
    marginTop: get(theme, 'margin.m24'),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  formSelectContainer: {
    alignSelf: 'flex-end',
    paddingBottom: 7,
    paddingLeft: `${get(theme, 'padding.p20')}`,
    width: 300,
    margin: '0 !important',
  },
  applicationsFormSelect: {
    width: 200,
    paddingLeft: `${get(theme, 'padding.p10')}`,
  },
  link: {
    cursor: 'pointer',
  },
  statusField: {
    display: 'flex',
  },
  statusText: {
    position: 'relative',
    top: '-2px',
  },
  statusIcon: {
    height: 18,
    marginRight: 4,
    verticalAlign: 'middle',
    width: 18,
  },
  available: {
    color: get(theme, 'color.success'),
  },
  pending: {
    color: get(theme, 'color.warning'),
  },
  disabled: {
    color: get(theme, 'color.disabledBackground'),
  },
  rejected: {
    color: get(theme, 'color.error'),
  },
  addApiButton: {
    marginTop: "1rem",
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  warningIcon: {
    color: get(theme, 'colorwarning'),
    marginLeft: get(theme, 'margin.m10'),
    marginRight: get(theme, 'margin.m4'),
    fontSize: 14,
    marginTop: get(theme, 'margin.m4'),
  },
  filtersContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100% !important",
    marginTop: "-1rem",
  },
  applicationFiltersContainer: {
    marginTop: "-1rem",
    display: "flex",
    alignItems: "center",
  },
  removeButton: {
    backgroundColor: get(theme, 'color.error'),
    borderColor: get(theme, 'color.error'),
    margin: `0 ${get(theme, 'margin.m2')}`,
    '&:hover': {
      backgroundColor: get(theme, 'color.errorHover'),
    },
  },
})

export default styles;